import { render, staticRenderFns } from "./customExcellentGoods.vue?vue&type=template&id=244788ce&scoped=true"
import script from "./customExcellentGoods.vue?vue&type=script&lang=js"
export * from "./customExcellentGoods.vue?vue&type=script&lang=js"
import style0 from "./customExcellentGoods.vue?vue&type=style&index=0&id=244788ce&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "244788ce",
  null
  
)

export default component.exports